import React from "react";
import "./profile-department.scss";

const departmentList = [
  { color: "#FCE8D2", text: "Sales", id: [1, 11, 21, 31, 41, 51] },
  { color: "#D6ECD2", text: "Marketing", id: [2, 12, 22, 32, 42, 52] },
  { color: "#FFD9E7", text: "AI Team", id: [3, 13, 23, 33, 43, 53] },
  { color: "#DEC3A6", text: "Finance", id: [4, 14, 24, 34, 44, 54] },
  { color: "#DDEAFF", text: "Accounting", id: [5, 15, 25, 35, 45, 55] },
  { color: "#CAC3D6", text: "IT", id: [6, 16, 26, 36, 46, 56] },
  {
    color: "#C3E0DF",
    text: "Engineering & Transformation",
    id: [7, 17, 27, 37, 47, 57],
  },
  { color: "#BAD1B6", text: "PMO", id: [8, 18, 28, 38, 48, 58] },
  { color: "#FFFDD9", text: "Data", id: [9, 19, 29, 39, 49, 59] },
  {
    color: "#E0C3CE",
    text: "Technology and Data",
    id: [10, 20, 30, 40, 50, 60],
  },
];

const ProfileDepartment: React.FC<{ department: string }> = ({
  department,
}) => {
  const userDetails = localStorage.getItem("userDetails")
    ? JSON.parse(localStorage.getItem("userDetails") || "{}")
    : null;
  const userDeptId = userDetails?.departmentId;
  const departmentInfo = departmentList.find((dept) =>
    dept.id.includes(userDeptId),
  );

  return (
    <span
      className={`profile-department-badge`}
      style={{ backgroundColor: departmentInfo?.color }}
    >
      {department}
    </span>
  );
};

export default ProfileDepartment;
